import { render, staticRenderFns } from "./EvaluaCurso.vue?vue&type=template&id=96bfd90e"
import script from "./EvaluaCurso.vue?vue&type=script&lang=js"
export * from "./EvaluaCurso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports